// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__38YmT","footer":"App_footer__2jWQq","follow":"App_follow__mm1o8","poweredby":"App_poweredby__Gs2Di"};